{
  "Billing": "Billing",
  "Return to App": "Return to App",
  "Home": "Home",
  "Calendar": "Calendar",
  "Dashboard": "Dashboard",
  "ATP": "ATP",
  "Subscriptions": "Subscriptions",
  "Payment Methods": "Payment Methods",
  "Purchases": "Purchases",
  "View Profile": "View Profile",
  "TrainingPeaks Athlete Since": "TrainingPeaks Athlete Since",
  "TrainingPeaks Coach Since": "TrainingPeaks Coach Since",
  "Invoice": "Invoice",
  "No results": "No results",
  "qtr": "qtr",
  "Show all transactions": "Show all transactions",
  "No transactions found": "No transactions found",
  "Loading purchases": "Loading purchases",
  "Error loading purchases": "Error loading purchases",
  "Active": "Active",
  "Inactive": "Inactive",
  "Cancelled": "Cancelled",
  "PastDue": "Past Due",
  "Trialing": "Trialing",
  "Next Renewal": "Next Renewal",
  "Manage": "Manage",
  "plus tax": "plus tax",
  "No subscriptions found": "No subscriptions found",
  "No purchases found": "No purchases found",
  "Show all": "Show all",
  "Show less": "Show less",
  "Date": "Date",
  "Description": "Description",
  "Amount": "Amount",
  "Status": "Status",
  "Paid": "Paid",
  "Failed": "Failed",
  "Pending": "Pending",
  "Refunded": "Refunded",
  "Loading": "Loading",
  "Error loading data": "Error loading data",
  "month": "month",
  "year": "year",
  "quarter": "quarter",
  "mo": "mo",
  "yr": "yr",
  "Default": "Default",
  "Expires": "Expires",
  "Card ending in": "Card ending in",
  "Flexible planning to fit your life": "Flexible planning to fit your life",
  "Actionable Insights to keep you on track": "Actionable Insights to keep you on track",
  "Strength training to avoid injury": "Strength training to avoid injury",
  "Ride the world inside on Virtual": "Ride the world inside on Virtual",
  "Any sport, any device, any time": "Any sport, any device, any time",
  "Annual": "Annual",
  "Monthly": "Monthly",
  "Billed USD $134.99/yr": "Billed USD $134.99/yr",
  "Most Popular": "Most Popular",
  "$19.95 $11.25/mo": "$19.95 $11.25/mo",
  "$19.95/mo": "$19.95/mo",
  "Checkout": "Checkout",
  "Progress starts with Premium.": "Progress starts with Premium.",
  "Add Card": "Add Card",
  "Close": "Close",
  "Primary": "Primary",
  "Delete": "Delete",
  "Make Primary": "Make Primary",
  "Error loading payment methods": "Error loading payment methods",
  "Your card has expired. Please add a new card.": "Your card has expired. Please add a new card.",
  "Unable to load payment form. Please try again later.": "Unable to load payment form. Please try again later.",
  "A temporary $1.00 charge will be made to validate your payment method. This charge is automatically refunded.": "A temporary $1.00 charge will be made to validate your payment method. This charge is automatically refunded.",
  "Payment method added successfully": "Payment method added successfully",
  "Default payment method updated": "Default payment method updated",
  "Payment method deleted": "Payment method deleted",
  "Failed to set default payment method": "Failed to set default payment method",
  "Failed to update default payment method": "Failed to update default payment method",
  "Failed to delete payment method": "Failed to delete payment method",
  "Maximize Your Premium Subscription \n Before You Go!": "Maximize Your Premium Subscription \n Before You Go!",
  "TrainingPeaks Virtual": "TrainingPeaks Virtual",
  "Ride inside with our virtual cycling experience": "Ride inside with our virtual cycling experience",
  "Strength Builder": "Strength Builder",
  "Create and save strength workouts": "Create and save strength workouts",
  "Metrics Charts": "Metrics Charts",
  "Analyze metrics from your synced devices": "Analyze metrics from your synced devices",
  "Performance Metrics": "Performance Metrics",
  "Fitness (CTL), Fatigue (ATL) and Form (TSB)": "Fitness (CTL), Fatigue (ATL) and Form (TSB)",
  "Peak Performances": "Peak Performances",
  "Track and compare your best efforts": "Track and compare your best efforts",
  "NEW!": "NEW!",
  "Cancel Subscription": "Cancel Subscription",
  "Renew Subscription": "Renew Subscription",
  "Complimentary": "Complimentary",
  "Your complimentary access is active through": "Your complimentary access is active through",
  "Keep your goals in sight -- renew Premium to stay on track for race day.": "Keep your goals in sight -- renew Premium to stay on track for race day.",
  "Renew": "Renew",
  "Auto-Renew Off": "Auto-Renew Off",
  "Access through": "Access through",
  "Turn Auto-Renew On": "Turn Auto-Renew On",
  "Are you sure you want to cancel coaching?": "Are you sure you want to cancel coaching?",
  "Reaching your goals takes the right fit. Before you cancel, let us know if you need to pause, adjust your package level, or speak directly with a Coach Match Specialist.": "Reaching your goals takes the right fit. Before you cancel, let us know if you need to pause, adjust your package level, or speak directly with a Coach Match Specialist.",
  "Pause, Adjust, or Contact Support": "Pause, Adjust, or Contact Support",
  "Yes, Cancel": "Yes, Cancel",
  "Keep My Coaching": "Keep My Coaching",
  "Coach Match subscription: Pause, Adjust, or Speak with Specialist": "Coach Match subscription: Pause, Adjust, or Speak with Specialist",
  "Hi Coach Match Team,\n\nI am reaching out regarding my coaching membership. Before deciding whether to cancel, I would like to [pause my membership / adjust my package level / speak with a Coach Match Specialist].\n\nMy account email is: [Your Email]\n\nThanks!": "Hi Coach Match Team,\n\nI am reaching out regarding my coaching membership. Before deciding whether to cancel, I would like to [pause my membership / adjust my package level / speak with a Coach Match Specialist].\n\nMy account email is: [Your Email]\n\nThanks!",
  "Before you go...": "Before you go...",
  "What's the reason for canceling?": "What's the reason for canceling?",
  "Price / Financial Reasons": "Price / Financial Reasons",
  "The subscription cost no longer fits my budget.": "The subscription cost no longer fits my budget.",
  "Injured / Health Reasons": "Injured / Health Reasons",
  "I'm unable to train due to injury or health.": "I'm unable to train due to injury or health.",
  "Finished Goal Event": "Finished Goal Event",
  "I completed my target race or event.": "I completed my target race or event.",
  "Poor Experience / Fit": "Poor Experience / Fit",
  "The coaching style or program wasn't the right match.": "The coaching style or program wasn't the right match.",
  "Temporary Pause / Restart Later": "Temporary Pause / Restart Later",
  "Life got busy — I'd like to come back when I'm ready.": "Life got busy — I'd like to come back when I'm ready.",
  "Other": "Other",
  "Optional: Why?": "Optional: Why?",
  "Continue": "Continue",
  "Keep Subscription": "Keep Subscription"
}
